import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { OktaAuthService } from '@okta/okta-angular';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private oktaAuth: OktaAuthService) { }

    private getToken(): Observable<string> {
        return from(this.oktaAuth.getAccessToken());
    }

    // keeping intercept, it might help with local proxy to remote server
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.headers.has('Skip-Auth-Interceptor')) {
            const headers = req.headers.delete('Skip-Auth-Interceptor');
            return next.handle(req.clone({ headers }));
        }
        return this.getToken().pipe(
            mergeMap((accessToken) => {
                const authReq = req.clone({
                    headers: req.headers.set('Authorization', 'Bearer ' + accessToken)
                });

                return next.handle(authReq);
            })
        );
    }
}
